/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { GetTrainingMaterialsResponse } from '../models/GetTrainingMaterialsResponse';
import type { SaveTrainingMaterialRequest } from '../models/SaveTrainingMaterialRequest';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class PcsConfigurationControllerv2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns GetTrainingMaterialsResponse
     * @throws ApiError
     */
    public pcsConfigurationControllerv2GetTrainingMaterials(): Observable<Array<GetTrainingMaterialsResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/pcsconfigurations/trainingmaterials',
        });
    }
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public pcsConfigurationControllerv2SaveTrainingMaterials(
        requestBody: Array<SaveTrainingMaterialRequest>,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/pcsconfigurations/trainingmaterials',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
